import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-ink px-8 py-24 text-paper sm:px-14 sm:py-32" data-id="element-187" data-mp="30xq5bd2y0iu9">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-188" data-mp="2w5gabimz0sl4">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-189" data-mp="2r7wuwfeje9rl">
          <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-190" data-mp="2r5kdq4gls3fl">
            Vous vous reconnaissez dans ces situations&nbsp;?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-paper/70" data-id="element-191" data-mp="2i55ioddu79yw">
            Si vous avez répondu oui au moins une fois, ce pack est fait pour vous.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-hand text-3xl text-pen-soft transition-colors duration-150 ease-out hover:text-paper" data-id="element-192" data-mp="289kj0lw8qlsb">
            Vous méritez mieux que cela
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-193" data-mp="6fcyqjq49j9p" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-194" data-mp="39mw6ite4k9pi">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-195" data-mp="3entxnvh44e35">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-pen-soft" data-id="element-196" data-mp="66z63c5rmg4d">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-197" data-mp="3sls2oa9jmy5z" />
                </span>
                <div data-id="element-198" data-mp="3sjxmf997vu88">
                  <h3 className="font-display text-2xl leading-tight sm:text-[1.7rem]" data-id="element-199" data-mp="1exl91uj7h2q">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-paper/70" data-id="element-200" data-mp="p4jivkv99o8m">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}